<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/2 w-full">
      <vx-card title="ข้อมูลผู้ใช้งาน" class="mb-8 pr-8">
        <div class="vx-row mb-4 mt-4">
          <div class="vx-col md:w-1/3 w-full text-right">
            <span>ชื่อเข้าใช้งาน</span>
            <span class="text-red align-text-bottom">*</span>
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vs-input class="w-full mr-6" v-model="username" name="username" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('username')">กรุณากรอกชื่อเข้าใช้งาน</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col md:w-1/3 w-full text-right">
            <span>ชื่อ - สกุล</span>
            <span class="text-red align-text-bottom">*</span>
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vs-input class="w-full" v-model="name" name="name" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('name')">กรุณากรอกชื่อ - สกุล</span>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col md:w-1/3 w-full text-right">
            <span>ตำแหน่ง/แผนก</span>
            <span class="text-red align-text-bottom">*</span>
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <v-select :options="department" :clearable="false" v-model="selectedDepartment" name="position" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('position')">กรุณาเลือกตำแหน่ง/แผนก</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full text-right mt-3">
            <vs-button color="danger" type="filled">ยกเลิก</vs-button>
            <vs-button color="primary" type="filled" class="ml-4" @click="submitData();">บันทึก</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col md:w-1/2 w-full">
      <vx-card title="เปลี่ยนรหัสผ่าน" class="pr-8">
        <div class="vx-row mb-4 mt-4">
          <div class="vx-col md:w-1/3 w-full text-right">
            รหัสผ่านเก่า:
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vs-input class="w-full" type="password" v-model="oldPass"/>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col md:w-1/3 w-full text-right">
            รหัสผ่านใหม่:
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vs-input class="w-full" type="password" v-model="newPass"/>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col md:w-1/3 w-full text-right">
            รหัสผ่านใหม่อีกครั้ง:
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vs-input class="w-full" type="password" v-model="newPassConfirm"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full text-right mt-3">
            <vs-button color="danger" type="filled">ยกเลิก</vs-button>
            <vs-button color="primary" type="filled" class="ml-4" @click="checkPassword()">บันทึก</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
  import moduleDepartment from "@/store/department/moduleDepartment.js";
  import moduleUser from "@/store/user/moduleUser.js";
  import vSelect from 'vue-select';
  import VuePerfectScrollbar from "vue-perfect-scrollbar";

  export default {
    components: {
      vSelect,
    },
    data() {
      return {
        user: '',
        selectedDepartment: { label: '', value: '' },
        username: '',
        name: '',
        password: '',
        oldPass: '',
        newPass: '',
        newPassConfirm: '',
      }
    },
    computed: {
      department() {
        let options = [];
        this.$store.state.department.items.forEach(function (item) {
          options.push({
            label: item.DepartOrPosition,
            value: item.DepartOrPosition
          })
        });
        return options;
      },
    },
    methods: {
      async init() {
        const member = await this.$store.state.user.item;
        const depart = await this.$store.state.department.items;
        this.username = member.usernameId;
        this.name = member.userFullname;
        this.password = member.passwordId;
        // depart.forEach((item) => {
        //   if (item.DepartOrPosition == this.user.positionname) {
            this.selectedDepartment = {
              label: member.positionname,
              value: member.positionname
            }
        //   }
        // });
        this.$vs.loading.close();
      },
      checkPassword() {
        if (this.oldPass === '' || this.newPass === '' || this.newPassConfirm === '') {
          const text = 'กรุณากรอกรหัสผ่านให้ครบ';
          this.warningDialog(text);
          return;
        }
        if (this.oldPass !== this.password) {
          const text = 'รหัสผ่านเก่าไม่ถูกต้อง';
          this.failDialog(text);
          return;
        }
        if (this.newPass !== this.newPassConfirm) {
          const text = 'รหัสผ่านใหม่ไม่ตรงกัน';
          this.failDialog(text);
          return;
        }
        this.submitPassword();
      },
      async submitPassword() {
        this.$vs.loading();
        const obj = {
          id: this.user._id,
          passwordId: this.newPass,
        };
        this.$store.dispatch("user/updateProfile", obj).then((res) => {
          if(res.status === 200) {
            const data = res.data;
            this.password = data.passwordId;
            this.$vs.loading.close();
            const text = 'เปลี่ยนรหัสผ่านสำเร็จ';
            this.successDialog(text);
          } else {
            this.$vs.loading.close();
            const text = 'เปลี่ยนรหัสผ่านไม่สำเร็จ';
            this.failDialog(text);
          }
        }).catch((error) => {
          this.$vs.loading.close();
          const text = 'เปลี่ยนรหัสผ่านไม่สำเร็จ';
          this.failDialog(text);
        });
      },
      async submitData() {
        await this.$validator.validateAll().then(result => {
          if (result) {
            this.$vs.loading();
            const obj = {
              id: this.user._id,
              usernameId: this.username,
              userFullname: this.name,
              positionname: this.selectedDepartment.label
            };
            this.$store.dispatch("user/updateProfile", obj).then((res) => {
              if(res.status === 200) {
                const data = res.data;
                this.$store.dispatch('updateUser', data);
                this.username = data.usernameId;
                this.name = data.userFullname;
                this.$vs.loading.close();
                const text = 'แก้ไขข้อมูลผู้ใช้งานสำเร็จ';
                this.successDialog(text);
              } else {
                this.$vs.loading.close();
                const text = 'แก้ไขข้อมูลผู้ใช้งานไม่สำเร็จ';
                this.failDialog(text);
              }
            }).catch((error) => {
              this.$vs.loading.close();
              const text = 'แก้ไขข้อมูลผู้ใช้งานไม่สำเร็จ';
              this.failDialog(text);
            });
          }
        })
      },
      warningDialog(message) {
        this.$vs.dialog({
          type: 'alert',
          color: 'warning',
          title: `คำเตือน`,
          text: message,
          acceptText: 'ปิด'
        })
      },
      failDialog(message) {
        this.$vs.dialog({
          type: 'alert',
          color: 'danger',
          title: `ผิดพลาด`,
          text: message,
          acceptText: 'ปิด'
        })
      },
      successDialog(message) {
        this.$vs.dialog({
          type: 'alert',
          color: 'success',
          title: `สำเร็จ`,
          text: message,
          acceptText: 'ปิด',
        })
      }
    },
    async created() {
      this.$vs.loading();
      const userSession = JSON.parse(sessionStorage.getItem('vuex'));
      this.user = userSession.owner.user.user;
      if(!moduleUser.isRegistered) {
        this.$store.registerModule('user', moduleUser)
        moduleUser.isRegistered = true
      }
      if (!moduleDepartment.isRegistered) {
        this.$store.registerModule('department', moduleDepartment);
        moduleDepartment.isRegistered = true;
      }
      await this.$store.dispatch("user/getUserById", this.user._id);
      await this.$store.dispatch("department/fetchDataListItems");
      this.init();
    }
  }
</script>
<style lang="scss">
  .input-file {
    position: absolute;
    z-index: 5;
    width: 135px;
    height: 39px;
    opacity: 0;
  }
</style>
